/**
 * Project: bicc-trafig-data-dashboard
 * Author: Rolf Alberth <rolf.alberth@bicc.de>
 * Last Modified: 2021-07-27 15:59:26
 * License: MIT License
 */


if (import.meta.env.DEV) {
    import('bootstrap/scss/bootstrap.scss')
}

import { createApp } from 'vue'
import App from './App.vue'

createApp(App)
    .mount('#app')
